import { Box, Container, Typography } from '@mui/material';

/**
 * Admin EORI number validation tool (ICS2-625).
 */
export default function EoriNumberValidation() {
  return (
    <Container maxWidth="xl" sx={{ px: 4, mt: 4, mb: 4 }}>
      <Box className="floating-box-newload" sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
          EORI Number Validation
        </Typography>
        <Typography variant="body1">This feature is provided for IT Admin use.</Typography>
      </Box>
    </Container>
  );
}
